'use client';

import { useCallback } from 'react';
import { usePriceConvert } from '@/lib/PriceContext';
import { t, type I18nKey } from '@/lib/i18n';

/** Client-side translation hook. Reads lang from PriceContext (localStorage). */
export function useT() {
  const { lang } = usePriceConvert();
  return useCallback((key: I18nKey) => t(key, lang), [lang]);
}
